// (c) chaehongee. Confidential and proprietary.

import i18n from '../i18n'
import styles from './ErrorFallback.module.css'

export function ErrorFallback() {
  return (
    <div className={styles.root}>
      <h1 className={styles.heading}>{i18n.t('errors:somethingWentWrong')}</h1>
      <p className={styles.message}>{i18n.t('errors:notifiedLookingInto')}</p>
      <button className={styles.buttonSolid} onClick={() => window.location.reload()}>
        {i18n.t('errors:reloadPage')}
      </button>
    </div>
  );
}

export function LayoutErrorFallback() {
  return (
    <div className={styles.layoutRoot}>
      <p className={styles.layoutHeading}>{i18n.t('errors:somethingWentWrong')}</p>
      <p className={styles.layoutMessage}>
        {i18n.t('errors:notifiedLookingInto')}
      </p>
      <button
        className={styles.buttonGhost}
        onClick={() => window.location.reload()}
      >
        {i18n.t('errors:reload')}
      </button>
    </div>
  );
}
